export default {
	TEMPLATES: 'companies/:company_id/templates/'
}
